import React, { Component } from 'react';

import PropTypes from 'prop-types';

import { Link, Redirect } from 'react-router-dom';

import { withStyles } from '@material-ui/core/styles';

import { Card, CardContent, Typography, Grid, Tooltip } from '@material-ui/core';

import { contactsRef } from '../../firebase';
import { toast } from 'react-toastify';

const styles = theme => ({
    title: {
        paddingLeft: '80px',
        paddingRight: '80px',
        paddingTop: '35px',
    },
    card: {
        marginTop: "30px",
        textAlign: "center",
        display: "inline-block",
        position: "relative",
        width: "100%",
        margin: "25px 0",
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.14)",
        borderRadius: "3px",
        color: "rgba(0, 0, 0, 0.87)",
        background: "#fff"
    },
    cardAvatar: {
        maxWidth: "130px",
        maxHeight: "130px",
        borderRadius: "50%",
        overflow: "hidden",
        boxShadow:
            "0 10px 30px -12px rgba(0, 0, 0, 0.42), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)"
    },
    img: {
        width: "100%",
        height: "auto",
        verticalAlign: "middle",
        border: "0"
    },
    textAlign: {
        textAlign: "center"
    },
    cardSubtitle: {
        color: "#999",
        fontSize: "1em",
        textTransform: "uppercase",
        marginTop: "10px",
        marginBottom: "10px"
    },
    cardTitle: {
        fontSize: "1.3em",
        marginTop: "10px",
        marginBottom: "10px"
    },
    cardDescription: {
        padding: "15px 20px",
        margin: "0 0 10px"
    },
    cardActions: {
        height: "auto",
        display: "inline"
    }
});

class Contact extends Component {
    state = {
        open: false,
        deleteStatus: false,
        deleteError: false,
        redirect: false,
        bgColor: '#fff',
        updateRequest: false
    };


    cardHovering = () => {
        this.setState({ bgColor: '#BBDEFB' });
    }

    cardNormal = () => {
        this.setState({ bgColor: '#FFF' });
    }

    render() {
        const { classes, children } = this.props;

        let childSection = []

        children.forEach((child, index) => childSection[index] = <div style={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
            <img src="https://firebasestorage.googleapis.com/v0/b/fir-kbaaz.appspot.com/o/avatars%2Fuser.png?alt=media&token=692478e2-252e-4503-8b8b-5553f5b58556" alt="..." style={{ height: '30px' }} />
            <Typography variant='title' className={classes.cardDescription}>
                {child}
            </Typography>
        </div>)

        console.log(childSection.length)

        var {
            firstName,
            lastName,
            email,
            phone,
            accepted,
            userId
        } = this.props.contact;


        var updateId = "/contacts/details/" + this.props.id;

        if (this.state.redirect) {
            return (
                <Redirect to='/sudo/contacts' />
            );
        }


        if(this.state.updateRequest) {
            return (
                <Redirect to={updateId}/>
            )
        }

        return (
            <Tooltip title='Click to update or view details'>
                <Card onMouseOver={this.cardHovering} onMouseLeave={this.cardNormal} onClick={() => this.setState({ updateRequest: true })} className={classes.card} >
                    <CardContent>
                        <Grid container xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Grid alignContent='center' item xs={4} sm={2} md={1} lg={1} xl={1}>
                                <div style={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <img src="https://firebasestorage.googleapis.com/v0/b/fir-kbaaz.appspot.com/o/avatars%2Fuser.png?alt=media&token=692478e2-252e-4503-8b8b-5553f5b58556" alt="..." style={{ height: '80px' }} />
                                </div>
                            </Grid>
                            <Grid item xs={8} sm={10} md={2} lg={2} xl={2} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <Typography variant='title' className={classes.cardDescription}>
                                    {firstName + ' ' + lastName}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={12} md={5} lg={5} xl={5} style={{ display: 'flex', flexDirection:'row', justifyContent: 'center', alignItems: 'center' }}>
                                {childSection}
                            </Grid>
                            <Grid item xs={8} sm={10} md={2} lg={2} xl={2} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <Typography variant='title' className={classes.cardDescription}>
                                    {phone}
                                </Typography>
                            </Grid>
                            <Grid item xs={8} sm={10} md={2} lg={2} xl={2} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <Typography variant='title' className={classes.cardDescription}>
                                    {email}
                                </Typography>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card >
            </Tooltip>
        );
    }
}

Contact.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Contact);



// WEBPACK FOOTER //
// ./src/components/Contacts/Contact.js